<template>
    <span ref="component"></span>
</template>

<script>
    export default {
        props: {
            mobile: {default: '1'},
            tablet: {default: '0'},
            showOtherQuestions: {default: '0'}
        },
        data() {
            return {}
        },
        mounted() {
            this.setQuestions();
            window.addEventListener('resize', this.setQuestions, true);

            $('.question-container').each(function(){
                $(this).data('orig-display', $(this).css('display'));
            });
        },
        methods: {
            setQuestions() {
                const excludeMobile = parseInt(this.mobile);
                const excludeTablet = parseInt(this.tablet);

                let breakpoint = 0;
                if (excludeMobile) breakpoint = 768;
                if (excludeTablet) breakpoint = 992;

                const questionContainer = $(this.$refs.component).closest('.question-container');
                if (window.innerWidth < breakpoint) {
                    if ( this.showOtherQuestions === '0' ) {
                      $('.question-container').hide();
                    }
                    $('#movenextbtn').css('visibility', 'hidden');
                    questionContainer.show();
                    questionContainer.find('.form-control').val('1');
                } else {
                    $('.question-container').each(function(){
                        $(this).css('display', $(this).data('orig-display'));
                    });
                    $('#movenextbtn').css('visibility', 'visible');
                    questionContainer.hide();
                    questionContainer.find('.form-control').val('0');
                }
            }
        }
    }
</script>
